import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getR1InvoiceInfo } from 'modules/accommodations/features/reservations/api';

export const useQueryGetR1InvoiceInfo = ({
  calculationId,
  enabled = true,
}: {
  calculationId: string;
  enabled?: boolean;
}) => {
  return useQuery(
    QUERY_KEYS.RESERVATION_R1_INVOICE_INFO,
    () => getR1InvoiceInfo({ calculationId }),
    { enabled, cacheTime: 0 },
  );
};
